import React from "react";
import { useNavigate } from "react-router-dom";
import GoogleDocsSVG from "../../../../assets/svg/google-docs.svg";
import { ROUTE_DESTINATIONS_CREATE } from "../../../../constants/routes";
import {
  DestinationTypeEnum,
  DestinationTypeMap,
} from "../../../../enums/destination";

const GoogleDocsCard = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-white text-gray-900 border border-gray-200 rounded-md max-w-xs p-4 flex flex-col gap-4 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-200">
      <img
        alt="google-docs-logo"
        src={GoogleDocsSVG}
        className="size-16"
      />
      <div className="font-semibold">Google Docs</div>
      <div className="text-gray-600 text-sm">
        Save your generated articles as Google Docs in your Google Drive
      </div>
      <button
        className="text-white bg-[#3186ff] rounded px-4 py-2 font-semibold hover:bg-[#1a6ff0] transition duration-200 shadow-sm"
        onClick={() =>
          navigate(
            ROUTE_DESTINATIONS_CREATE +
              `?type=${DestinationTypeMap[DestinationTypeEnum.GOOGLE_DOCS]}`
          )
        }
      >
        Add
      </button>
    </div>
  );
};

export default GoogleDocsCard;
